import React from "react";

const SearchBox = (props) => {
    return (
        <div className="script__search">
            <h2>Movie Search </h2>
            <input 
                className="form_control" 
                placeholder="Search Movie" 
                value={props.value}
                onChange={(event)=>props.setSearchValue(event.target.value)}
            ></input>
        </div>
    )
}

export default SearchBox;